import { Diagnostic } from "../models/diagnostic.js";

/**
 * Checks for Java SDK related issues, specifically checking JDK version compatibility.
 * RULE: JDK TOO OLD (JDK < 17 when React Native version >= 0.80)
 */
export function checkJavaDiagnostic(
  javaVersion: string | null,
  reactNativeVersion: string | null
): Diagnostic[] {
  const diagnostics: Diagnostic[] = [];

  if (!javaVersion) {
    return diagnostics;
  }

  // Extract major Java version, e.g. "17.0.1" -> 17, "8" -> 8
  const javaMajor = parseInt(javaVersion.split(".")[0] || "", 10);

  if (!isNaN(javaMajor) && javaMajor < 17) {
    if (reactNativeVersion) {
      const match = reactNativeVersion.match(/^(\d+)\.(\d+)/);
      if (match && match[1] !== undefined && match[2] !== undefined) {
        const rnMajor = parseInt(match[1], 10);
        const rnMinor = parseInt(match[2], 10);

        // Check if React Native version is >= 0.80
        if (rnMajor > 0 || (rnMajor === 0 && rnMinor >= 80)) {
          diagnostics.push({
            id: "jdk-too-old",
            title: "JDK Version Mismatch",
            severity: "error",
            detected: `JDK v${javaVersion} with React Native v${reactNativeVersion}`,
            explanation: `React Native 0.80+ requires JDK 17 or newer. Your current JDK version (${javaVersion}) is too old.`,
            symptoms: [
              "Gradle build failure",
              "Android build errors (e.g. Unsupported class file major version)",
            ],
            fixes: [
              "Install JDK 17 or newer (Zulu or Temurin OpenJDK recommended).",
              "Update your JAVA_HOME environment variable to point to the new installation.",
              "Ensure the JDK binary directory is correctly added to your system PATH.",
            ],
            documentationUrl: "https://reactnative.dev/docs/environment-setup",
          });
        }
      }
    }
  }

  return diagnostics;
}
